import {REQUEST_SUCCESS} from "../../../requests/requestsReducer"
import {getNotDeprecatedCivility} from "../../../../utils/civility"
import {RequestInfo, RequestKeys} from "../../../../constants/requests"
import {
    DISCONNECT_USER,
    GET_USER_INFO_FAILURE,
    GET_USER_INFO_SUCCESS,
    MAJ_SELECTED_AREA,
} from "../../../../actions/sessionStorage/user/userActionTypes"

const details = (state = {}, action = {}) => {
    switch (action.type) {
        case GET_USER_INFO_SUCCESS:
            if (action.response.intervenant && action.response.intervenant.id) {
                return {
                    firstName: action.response.prenom,
                    lastName: action.response.nom,
                    socialReason: action.response.raisonSociale,
                    login: action.response.identifiant,
                    intervenant: {
                        id: action.response.intervenant.id,
                        type: action.response.intervenant.type,
                        contactStatus: action.response.intervenant.statutContact,
                    },
                }
            } else if (action.response.beneficiairePourEchange) {
                return {
                    firstName: action.response.prenom,
                    lastName: action.response.nom,
                    login: action.response.identifiant,
                    mail: action.response.email,
                    beneficiaryForTrade: {
                        phoneNumber: action.response.beneficiairePourEchange.telephone,
                        birthDate: action.response.beneficiairePourEchange.dateNaissance,
                        fromBackOffice: action.response.beneficiairePourEchange.viaBackOffice,
                        zoneAddress0: action.response.beneficiairePourEchange.zoneAdresse0,
                        zoneAddress1: action.response.beneficiairePourEchange.zoneAdresse1,
                        zoneAddress2: action.response.beneficiairePourEchange.zoneAdresse2,
                        zoneAddress3: action.response.beneficiairePourEchange.zoneAdresse3,
                        postalCode: action.response.beneficiairePourEchange.codePostal,
                        town: action.response.beneficiairePourEchange.ville,
                        contracts: action.response.beneficiairePourEchange.contrats.map(c => ({
                            id: c.id,
                            supportType: c.typePriseEnCharge,
                        })),
                        tradesParameters: action.response.beneficiairePourEchange.parametresEchange.map(pe => ({
                            contractId: pe.idContrat,
                            startProductType: pe.typeProduitDepart,
                            finalProductType: pe.typeProduitFinal,
                            enableTrade: pe.autorisationEchange,
                            feeAmount: pe.montantFrais,
                            thresholdAmount: pe.montantPlancher,
                            feeRate: pe.tauxFrais,
                        })),
                    },
                }
            } else if (action.response.beneficiaire) {
                const details = {
                    cesu: {
                        firstName: action.response.prenom,
                        lastName: action.response.nom,
                        login: action.response.identifiant,
                        mail: action.response.email,
                        fromBackOffice: action.response.beneficiaire.viaBackOffice,
                        readOnly: action.response.beneficiaire.lectureSeule,
                        beneficiary: {
                            allowAllPaymentModes: action.response.beneficiaire.autoriserToutTypePaiements,
                            civility: getNotDeprecatedCivility(action.response.beneficiaire.civilite),
                            cesuCode: action.response.beneficiaire.codeCESU,
                            birthDate: action.response.beneficiaire.dateNaissance,
                            zoneAddress0: action.response.beneficiaire.zoneAdresse0,
                            zoneAddress1: action.response.beneficiaire.zoneAdresse1,
                            zoneAddress2: action.response.beneficiaire.zoneAdresse2,
                            zoneAddress3: action.response.beneficiaire.zoneAdresse3,
                            postalCode: action.response.beneficiaire.codePostal,
                            town: action.response.beneficiaire.ville,
                            mainPhoneNumber: action.response.beneficiaire.telephonePrincipal,
                            secondaryPhoneNumber: action.response.beneficiaire.telephoneSecondaire,
                            mailOffers: action.response.beneficiaire.offresMail,
                            isCompteEbUnique: action.response.beneficiaire.compteEbUnique,
                            numeroBeneficiaireSap: action.response.beneficiaire.numeroBeneficiaireSap,
                            acceptOffreCommerciale: action.response.beneficiaire.acceptOffreCommerciale,
                            acceptCguEspaceBenef: action.response.beneficiaire.acceptCguEspaceBenef,
                        },
                    },
                }
                if (action.response.beneficiaire.compteEbUnique) {
                    details.sap = {
                        civilite: getNotDeprecatedCivility(action.response.beneficiaire.civilite),
                        nom: action.response.nom,
                        prenom: action.response.prenom,
                        beneficiaireId: action.response?.ebuData?.idBeneficiaireSap,
                        compteEBCESU: action.response?.ebuData?.idBeneficiaireCesu,
                        espaces: action.response.ebuData?.clients?.map(client => ({
                            idClient: client.idClient,
                            numClient: client.numClient,
                            raisonSociale: client.raisonSocialeClient,
                            activateAici: client.activateAici,
                        })),
                        selectedArea: {
                            civiliteBeneficiaire: getNotDeprecatedCivility(action.response.beneficiaire.civilite),
                            clientEbUnique: action.response.beneficiaire.compteEbUnique,
                            idBeneficiaire: action.response?.ebuData?.idBeneficiaireSap,
                            idClient: action.response.ebuData?.clients?.[0]?.idClient,
                            nomBeneficiaire: action.response.nom,
                            numClient: action.response.ebuData?.clients?.[0]?.numClient,
                            prenomBeneficiaire: action.response.prenom,
                            raisonSociale: action.response.ebuData?.clients?.[0]?.raisonSocialeClient,
                            activateAici: action.response.ebuData?.clients?.[0]?.activateAici,
                        },
                    }
                }
                return details
            } else {
                return {
                    firstName: action.response.prenom,
                    lastName: action.response.nom,
                    login: action.response.identifiant,
                    mail: action.response.email,
                    socialReason: action.response.raisonSociale,
                    clientType: action.response.typeDeClient,
                    clientId: action.response.idClient,
                    clientNumber: action.response.numClient,
                    expandedMode: action.response.modeEtendu,
                    reportableEmployerContribution: action.response.abondementReportable,
                    siret: action.response.siret,
                    segmentId: action.response.idSegment,
                    acceptCguEspaceFinanceur: action.response.acceptCguEspaceFinanceur,
                }
            }
        case MAJ_SELECTED_AREA:
            return {
                ...state,
                sap: {
                    ...state.sap,
                    selectedArea: {
                        ...state.sap.selectedArea,
                        idClient: action.response.idClient,
                        numClient: action.response.numClient,
                        raisonSociale: action.response.raisonSocialeClient,
                        activateAici: action.response.activateAici,
                    },
                },
            }
        case GET_USER_INFO_FAILURE:
        case DISCONNECT_USER:
            return {}
        case REQUEST_SUCCESS:
            if (action.requestKeyName === RequestInfo[RequestKeys.UPDATE_BENEFICIARY_CGU_ACCEPTATION_DATE].name) {
                return {
                    ...state,
                    cesu: {
                        ...state.cesu,
                        beneficiary: {
                            ...state.cesu.beneficiary,
                            acceptCguEspaceBenef: true,
                        },
                    },
                }
            } else if (
                action.requestKeyName === RequestInfo[RequestKeys.UPDATE_INTERLOCUTEUR_CLIENT_CGU_ACCEPTATION_DATE].name
            ) {
                return {
                    ...state,
                    acceptCguEspaceFinanceur: true,
                }
            }
            return state
        default:
            return state
    }
}

export default details

/**
 * Get user details from the store.
 */
export const getDetails = state => state
